/** Draw control-room endpoints (outcome module, docs/modules/outcome.md). */
import type {
  DrawAdminDto,
  DrawAuditDto,
  DrawListDto,
  DrawListQuery,
  DrawPrecheckDto,
  DrawVerifyDto,
  PublishStaticResponse,
  RedrawRequest,
  RedrawResponse,
  RevealNextRequest,
  RevealNextResponse,
  RevealRehearsalDto,
  RunDrawRequest,
  RunDrawResponse,
} from '@windrop/contracts';
import { api } from '../../lib/api/client';
import { readRuntimeConfig } from '../../lib/runtime-config';

export const drawsApi = {
  list: (query: DrawListQuery = {}) => api.get<DrawListDto>('/v1/admin/draws', query),
  get: (drawId: string) => api.get<DrawAdminDto>(`/v1/admin/draws/${encodeURIComponent(drawId)}`),
  precheck: (drawId: string) =>
    api.get<DrawPrecheckDto>(`/v1/admin/draws/${encodeURIComponent(drawId)}/precheck`),
  audit: (drawId: string) => api.get<DrawAuditDto>(`/v1/admin/draws/${encodeURIComponent(drawId)}/audit`),
  verify: (drawId: string) => api.get<DrawVerifyDto>(`/v1/admin/draws/${encodeURIComponent(drawId)}/verify`),
  rehearsal: (drawId: string) =>
    api.get<RevealRehearsalDto>(`/v1/admin/draws/${encodeURIComponent(drawId)}/rehearsal`),
  run: (lotteryId: string, body: RunDrawRequest) =>
    api.post<RunDrawResponse>(`/v1/admin/lotteries/${encodeURIComponent(lotteryId)}/draw`, body),
  revealNext: (drawId: string, body: RevealNextRequest) =>
    api.post<RevealNextResponse>(`/v1/admin/draws/${encodeURIComponent(drawId)}/reveal-next`, body),
  publishStatic: (drawId: string) =>
    api.post<PublishStaticResponse>(`/v1/admin/draws/${encodeURIComponent(drawId)}/publish-static`, {}),
  redraw: (drawId: string, body: RedrawRequest) =>
    api.post<RedrawResponse>(`/v1/admin/draws/${encodeURIComponent(drawId)}/redraw`, body),
  /** Fairness export (operator download; the public copy lives at /v1/draws/:id/fairness/bundle.json). */
  bundleUrl: (drawId: string) =>
    `${readRuntimeConfig().apiOrigin}/v1/admin/draws/${encodeURIComponent(drawId)}/bundle.json`,
};
